import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext.jsx';
import { useStore } from '../context/StoreContext.jsx';
import { LanguageSwitcher } from './LanguageSwitcher.jsx';

export function Header() {
  const { t } = useLanguage();
  const { storeConfig } = useStore();

  return (
    <header className="site-header">
      <div className="announcement-bar">
        <div className="container">
          <span>{t('announcement')}</span>
          <span className="ltr-only font-mono">{storeConfig.contact.phone}</span>
        </div>
      </div>

      <div className="container header-inner">
        <Link to="/" className="brand-logo" aria-label="AutoAlibaba — accueil">
          <img src="/assets/autoalibaba-logo.webp" alt="AutoAlibaba" />
        </Link>

        <nav className="main-nav" aria-label="Navigation principale">
          <NavLink to="/" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} end>
            {t('home')}
          </NavLink>
          <NavLink to="/catalogue" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            {t('catalog')}
          </NavLink>
          <NavLink to="/suivi" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            {t('orderTracking')}
          </NavLink>
          <NavLink to="/contact" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
            {t('contact')}
          </NavLink>
        </nav>

        <div className="header-actions">
          <LanguageSwitcher />
          <Link to="/admin" className="btn btn-outline" style={{ fontSize: '0.8125rem', padding: '0.375rem 0.75rem' }}>
            {t('admin')}
          </Link>
        </div>
      </div>
    </header>
  );
}
